import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Profile.css';
import Header from '../components/Header';

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo') || '{}');

  useEffect(() => {
    if (!userInfo || !userInfo.uyeno) {
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
  }, [userInfo, navigate]);

  if (!userInfo || !userInfo.uyeno) {
    return (
      <div className="profile-container">
        <Header title="Profilim" />
        <div className="profile-card main-content">
          <div className="profile-info">
            <div className="profile-name">Kullanıcı bilgisi bulunamadı.</div>
            <div className="profile-id">Lütfen tekrar giriş yapınız.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <Header title="Profilim" />
      <div className="profile-card main-content">
        <img
          src={userInfo.KARTRESIM ? `https://crm.havalimanitaksi.com.tr/media/natural/${userInfo.KARTRESIM}` : '/images/default-profile.png'}
          alt="Profil"
          className="profile-avatar"
        />
        <div className="profile-info">
          <div className="profile-name">{userInfo.ADI} {userInfo.SOYADI}</div>
          <div className="profile-id">Üye No: {userInfo.uyeno}</div>
          <div className="profile-group">Grup: {userInfo.grubu}</div>
          <div className="profile-status">Durum: {userInfo.durumu}</div>
        </div>
      </div>
    </div>
  );
};

export default Profile; 